export default __webpack_public_path__ + "static/media/Characters.42a83684.jpg";